// src/subscreens/About/About.js
import React from 'react';
import { FaBrain, FaUsers, FaChartLine, FaTrophy } from 'react-icons/fa';
import '../../assets/css/about/About.css';

const About = () => {
  const features = [
    {
      icon: <FaBrain size={50} />,
      title: "AI-Powered Summaries",
      description: "Advanced AI technology that transforms lengthy study materials into concise, easy-to-understand summaries."
    },
    {
      icon: <FaUsers size={50} />,
      title: "Collaborative Spaces",
      description: "Create and join study groups with classmates, share resources, and learn together in real-time."
    },
    {
      icon: <FaChartLine size={50} />,
      title: "Performance Tracking",
      description: "Monitor your academic progress with detailed analytics and insights to identify areas for improvement."
    },
    {
      icon: <FaTrophy size={50} />,
      title: "Quiz & Competitions",
      description: "Test your knowledge through interactive quizzes and compete with peers to stay motivated."
    }
  ];

  return (
    <div className="ab-about-page">
      {/* About Hero Section */}
      <section className="ab-about-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h1 className="ab-about-hero-title">About CircleHub</h1>
              <p className="ab-about-hero-description">
                CircleHub is revolutionizing the way students learn by combining the power of artificial intelligence 
                with collaborative study environments. We believe that learning is better when done together, and our 
                platform is designed to make education more accessible, efficient, and enjoyable for students worldwide.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="ab-about-hero-image">
                <img 
                  src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&h=400&fit=crop" 
                  alt="Students collaborating" 
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why CircleHub Section */}
      <section className="ab-why-circlehub-section py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="ab-section-title">Why CircleHub?</h2>
      
            </div>
          </div>
          <div className="row g-4">
            {features.map((feature, index) => (
              <div className="col-lg-6 col-md-6" key={index}>
                <div className="ab-why-card">
                  <div className="ab-why-icon">
                    {feature.icon}
                  </div>
                  <h4 className="ab-why-title">{feature.title}</h4>
                  <p className="ab-why-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How CircleHub Helps Section */}
      <section className="ab-helps-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="ab-section-title mb-4">How CircleHub Helps Students</h2>
          
              <ul className="ab-helps-list">
                <li>Access AI-generated summaries that save hours of study time</li>
                <li>Connect with peers who share similar academic interests and goals</li>
                <li>Track progress and identify areas needing improvement through detailed analytics</li>
                <li>Participate in engaging quizzes and competitions to reinforce learning</li>
                <li>Share and access quality study materials from a global student community</li>
                <li>Stay motivated with gamification features and achievement badges</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="ab-helps-image-wrapper">
                <div className="ab-helps-image-overlay"></div>
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop" 
                  alt="Students working together" 
                  className="img-fluid rounded ab-helps-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="ab-vision-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2 className="ab-section-title mb-4">Vision for the Future</h2>
              <p className="ab-vision-text">
                We envision CircleHub as the world's largest student collaboration platform, where millions of learners 
                from every corner of the globe come together to share knowledge, inspire each other, and achieve 
                academic excellence. Our vision extends beyond just a study platform—we aim to create a movement that 
                transforms education by making quality learning resources accessible to everyone, regardless of their 
                location or background. We see a future where AI and human collaboration work hand-in-hand to unlock 
                every student's full potential, creating a more educated, connected, and empowered generation ready 
                to tackle the challenges of tomorrow.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="ab-cta-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="ab-cta-title mb-4"></h2>
              <p className="ab-cta-description mb-4">

              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;